// removed by extract-text-webpack-plugin
module.exports = {"slick-next":"_2VbnZZt_VQQL3GxB1TOJss","slick-prev":"_3UfgO25VVqkZu7HHQpZv0p","carousel":"_2l3OZJ_qkBM8YtdiRWdOto","carousel__nav_prev":"_7VEBhJWAWl4YyFIwzOmtc","carousel__nav_next":"_3SrGYNIV647rtyZ2gHdqLd","prev":"n1sAOHfH_s9edEjIuersJ","next":"_2DY19BiyxniHk0f6ZvFfaJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/carousel.scss
// module id = 579
// module chunks = 0